<template>
  <v-card class="idcs-main-back">
    <v-card-subtitle>
      <v-btn icon class="mr-4" @click="printPage">
        <v-icon>mdi-printer</v-icon>
      </v-btn>
      <span class="d-inline-block mr-5">
        <v-icon color="white" class="idcs-t-sell idcs-legend-icon mr-2">fa-shopping-cart</v-icon>
        <span>{{$t('card.legend.purchase.'+$store.getters.iface)}}</span>
      </span>
      <span class="d-inline-block mr-5">
        <v-icon color="white" class="idcs-t-buy idcs-legend-icon mr-2">fa-money-bill-wave</v-icon>
        <span>{{$t('card.legend.sell.'+$store.getters.iface)}}</span>
      </span>
      <span class="d-inline-block mr-5" v-if="$store.getters.iface=='3'">
        <v-icon color="white" class="idcs-legend-icon error mr-2">fa-cut</v-icon>
        <span>{{$t('card.legend.burn')}}</span>
      </span>
      <span class="d-inline-block mr-5">
        <v-icon color="white" class="idcs-t-canceled idcs-legend-icon mr-2">fa-times-circle</v-icon>
        <span>{{$t('card.legend.reversal')}}</span>
      </span>
      <span class="d-inline-block">
        <v-icon color="white" class="idcs-t-reversal idcs-legend-icon mr-2">fa-exclamation</v-icon>
        <span>{{$t('card.legend.reversed')}}</span>
      </span>
    </v-card-subtitle>
    <v-card-text>
      <v-simple-table :fixed-header="true">
        <table>
          <thead>
            <tr>
              <th class="idcs-th-back"></th>
              <th class="idcs-th-back">#</th>
              <template v-for="col in columns">
                <th :class="'idcs-th-back text-'+col.align" :key="col.value">{{$t(col.name)}}</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item,i) in items_">
              <tr v-if="item.diff11" :key="item.id">
                <td class="idcs-th-back" align="center">
                  <v-icon dark :class="'idcs-legend-icon error'">fa-cut</v-icon>
                </td>
                <td class="error">{{i+1}}</td>
                <td
                  v-for="col in columns"
                  :key="col.value"
                  :align="col.align"
                  :class="tdClass(item)+col.class"
                >{{ autoformat(col.filter,item[col.value]) }}</td>
                <!-- <td class="error">{{item.created|dt-time}}</td>
                <td class="error" :colspan="columns.length-2" align="right"><span>Сгорает -</span><span>{{item.diff|currency}}</span></td>
                <td class="error" :colspan="columns.length-2" align="right"><span>Сгорает -</span><span>{{item.diff|currency}}</span></td>
                <td class="error" :colspan="columns.length-2" align="right"><span>Сгорает -</span><span>{{item.diff|currency}}</span></td>
                <td class="error" align="right">{{item.debit_0|currency}}</td>-->
              </tr>
              <tr v-else :key="item.id">
                <td class="idcs-th-back" align="center">
                  <v-icon dark :class="'idcs-legend-icon '+tdClass(item)" v-text="rowIcon(item)"></v-icon>
                </td>
                <td :class="tdClass(item)">{{i+1}}</td>
                <td
                  v-for="col in columns"
                  :key="col.value"
                  :align="col.align"
                  :class="tdClass(item)+col.class"
                >
                  <span>{{ autoformat(col.filter,item[col.value],item,col) }}</span>
                  <v-btn
                    v-if="col.value=='status' && (item[col.value]==200 || item[col.value]==203) && $store.getters.test('ftrstat.w')"
                    icon
                    @click="confirmChangeTransStatus(item)"
                  >
                    <v-icon color="error">mdi-refresh</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </v-simple-table>
    </v-card-text>
    <v-dialog width="400" persistent v-model="d_confirm">
      <v-card>
        <v-card-title>
          <i18n path="dialog.tchangettl" />
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <i18n path="dialog.tchangeqst" class="font-weight-bold" />
            </v-col>
            <v-col cols="12">
              <i18n path="field.created" class="mr-2"></i18n>
              <span>{{currTrans.created}}</span>
            </v-col>
            <v-col>
              <i18n path="field.card" class="mr-2"></i18n>
              <span>{{currTrans.card}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <i18n :path="colLabel('amount1')" class="mr-2"></i18n>
              <span>{{currTrans.amount1 | currency}}</span>
            </v-col>
            <v-col cols="12">
              <i18n :path="colLabel('amount2')" class="mr-2"></i18n>
              <span>{{currTrans.amount2 | currency}}</span>
            </v-col>
            <v-col>
              <i18n path="field.status" class="mr-2"></i18n>
              <v-chip :color="currTrans.status==200?'success':''">{{currTrans.status}}</v-chip>
              <span class="mx-4">==></span>
              <v-chip :color="currTrans.status!=200?'success':''">{{currTrans.status==200?203:200}}</v-chip>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="error" @click="d_confirm=false"><i18n path="button.cancel" /></v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="changeTransStatus" :disabled="active"><i18n path="button.ok" /></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import app from "@/app.js";
export default {
  name: "CardTransactionTable",
  props: {
    items: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    columns: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    reverse: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    items_() {
      return this.items;
    },
  },
  data() {
    return {
      active: false,
      d_confirm: false,
      currTrans: {},
    };
  },
  methods: {
    colLabel(l) {
      try {
        return this.columns.find((e) => e.value == l).name;
      } catch (error) {
        return l;
      }
    },
    confirmChangeTransStatus(i) {
      this.currTrans = { ...i };
      this.d_confirm = true;
    },
    changeTransStatus() {
      this.active = true;
      app
        .changeTransStatus({
          idx: this.currTrans.idx,
          status: this.currTrans.status,
        })
        .then((r) => {
          if (r.count) {
            const ind = this.items.findIndex(
              (e) => e.idx == this.currTrans.idx
            );
            this.currTrans.status = this.currTrans.status == 200 ? 203 : 200;
            this.items.splice(ind, 1, this.currTrans);
          }
        })
        .finally(() => {
          this.active = false;
          this.d_confirm = false;
        });
    },
    printPage() {
      let headers = {
        title: this.$t("report.title.trans"),
        created: new Date().toString(),
        filter: {
          card: this.items[0].card,
        },
      };
      let footers = { totals: {} };
      this.columns.forEach((e) => {
        e.text = this.$t(e.name);
      });
      app.generatePrintPage(
        { items: this.items_ },
        this.columns,
        headers,
        footers
      );
    },

    tdClass(i) {
      if (i.diff) return "error ";
      if (i.status == 200) {
        if (this.reverse) return i.amount1 ? "idcs-t-sell " : "idcs-t-buy ";
        return i.amount1 ? "idcs-t-buy " : "idcs-t-sell ";
      }
      if (i.status == 201) return "idcs-t-reversal ";
      if (i.status == 202) return "idcs-t-canceled ";
    },
    rowIcon(i) {
      if (i.diff) return "fa-cut";
      if (i.status == 200) {
        if (this.reverse)
          return i.amount1 ? "fa-shopping-cart " : "fa-money-bill-wave ";
        return i.amount1 ? "fa-money-bill-wave " : "fa-shopping-cart ";
      }
      if (i.status == 201) return "fa-exclamation";
      if (i.status == 202) return "fa-times-circle";
    },
    autoformat(filter, val, rec, c) {
      if (c.value == "amount2" && rec.status == "202") {
        return this.$t("field.rec_nr").toLowerCase() + rec.rec_nr;
      }
      if (c.value == "amount2" && rec.status == "201") {
        return this.$t("field.rec_nr").toLowerCase() + rec.amount2;
      }
      if (filter == "dt-only") return this.$options.filters["dt-only"](val);
      if (filter == "dt-time") return this.$options.filters["dt-time"](val);
      if (filter == "currency") return this.$options.filters.currency(val);
      if (filter == "percent") return this.$options.filters.percent(val);
      if (filter == "status") return this.$t("status." + val);
      return val;
    },
  },
};
</script>

<style scoped>
</style>